module.exports = __webpack_public_path__ + "img/phone-right-icon.04ec96fb.svg";